export default __webpack_public_path__ + "static/media/ses.7ad0ec78.svg";